import React from 'react';
import _ from 'lodash';
import { useGetAllCourierPartnersCachedQuery } from '../../../redux/commonApiCalls';
import AbdSearchableSelect from './AbdSearchableSelect';

/**
 * V2-only courier filter. Local fork of the shared {@code CourierFilter} —
 * adds label / placeholder / size pass-through without touching the shared
 * component.
 */
export default function AbdCourierFilter({
    filterList = null,
    type = null,
    fullWidth = true,
    label = 'Select Courier',
    placeholder,
    size,
}) {
    const andfilter = [{ field: 'is_deleted', operator: 'eq', value: '0' }];
    const filter = {
        andfilter,
        offset: 0,
        limit: 1000,
        skipCount: true,
        includes: 'id,name,cpAccountCode,prozoId,supportedShipmentType,isBlended,type',
    };
    const { data } = useGetAllCourierPartnersCachedQuery(filter);
    const filteredData = data?.filter((val) => {
        if (filterList && type) return val.supported_shipment === filterList && val.type === type;
        if (filterList) return val.supported_shipment === filterList;
        if (type) return val.type === type;
        return true;
    });

    return (
        <AbdSearchableSelect
            fullWidth={fullWidth}
            name='courier'
            label={label}
            placeholder={placeholder}
            size={size}
            options={_.orderBy(filteredData, 'name').map((val) => ({
                value: val.id,
                label: `${val.cpAccountCode} (${val.prozoId})`,
                additionalData: val.prozoId,
            }))}
        />
    );
}
